import gql from "graphql-tag";

const UserFragment = gql`
  fragment UserFragment on User {
    id
    createdAt
    firstName
    groupName
    groupId
    segmentIds
    lastName
    email
    subscribedToNewsletter
    addresses {
      city
      company
      country {
        id
        name
      }
      firstName
      id
      isDefaultBilling
      isDefaultShipping
      lastName
      postcode
      street
      street2
      telephone
    }
    wishList
  }
`;

export default UserFragment;
